import { EyeIcon } from '@heroicons/react/24/outline';
import { Download01Icon, HeartIcon } from '@langchain/untitled-ui-icons';
import { Stack, Typography } from '@mui/joy';

import { getNumberWithSuffix } from '@/utils/hub';

import { useRepoData } from './hooks/useRepoData';

const RepoMetadata = ({ inHub }: { inHub: boolean }) => {
  const { repoObj } = useRepoData(inHub);

  return (
    <Stack
      direction="row"
      spacing={1}
      divider={<Typography level="body1">&bull;</Typography>}
      alignItems={'center'}
    >
      <div className="flex items-center gap-1 whitespace-nowrap text-sm">
        <HeartIcon className="size-4" />{' '}
        {getNumberWithSuffix(repoObj?.repo?.num_likes)}
      </div>
      <div className="flex items-center gap-1">
        <EyeIcon />
        {getNumberWithSuffix(repoObj?.repo?.num_views)}
      </div>
      <div className="flex items-center gap-1 whitespace-nowrap text-sm">
        <Download01Icon className="size-4" />{' '}
        {getNumberWithSuffix(repoObj?.repo?.num_downloads)}
      </div>
    </Stack>
  );
};

export default RepoMetadata;
